import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Shield, CalendarRange, Users, LogOut, BookOpen } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ROLES } from "@/lib/constants";

const NavItem = ({ to, icon: Icon, label, testid }) => (
  <NavLink
    to={to}
    end
    data-testid={testid}
    className={({ isActive }) =>
      `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
        isActive ? "bg-sky-500/15 text-sky-300 border border-sky-500/30" : "text-slate-400 hover:text-slate-100 hover:bg-white/5 border border-transparent"
      }`
    }
  >
    <Icon className="w-4 h-4" /> <span className="hidden lg:inline">{label}</span>
  </NavLink>
);

export default function Layout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex bg-[#0b1329] text-slate-100">
      <aside className="no-print w-16 lg:w-60 shrink-0 bg-[#090f20] border-r border-white/10 flex flex-col p-3 gap-2 sticky top-0 h-screen">
        <div className="flex items-center gap-3 px-1 py-3 mb-4" data-testid="brand-block">
          <img src="/aprendendo-logo.png" alt="EventPOL · Aprendendo" className="w-10 h-10 lg:w-12 lg:h-12 shrink-0 rounded-full shadow-lg shadow-sky-500/20" data-testid="brand-logo" />
          <div className="hidden lg:block leading-tight min-w-0">
            <div className="font-display font-bold text-sm">EventPOL</div>
            <div className="text-[10px] text-sky-300/80">por Aprendendo</div>
            <div className="font-mono text-[9px] text-slate-500 tracking-widest mt-1 flex items-center gap-1"><Shield className="w-3 h-3" /> POLICÍAS DE GALICIA</div>
          </div>
        </div>
        <NavItem to="/" icon={CalendarRange} label="Eventos" testid="nav-events-link" />
        {user?.role === "admin" && <NavItem to="/users" icon={Users} label="Usuarios" testid="nav-users-link" />}
        <NavItem to="/manual" icon={BookOpen} label="Manual" testid="nav-manual-link" />
        <div className="mt-auto border-t border-white/10 pt-3">
          <div className="hidden lg:block px-2 mb-2">
            <div className="text-sm font-medium truncate" data-testid="current-user-name">{user?.name}</div>
            <div className="font-mono text-[10px] text-amber-400 tracking-widest uppercase" data-testid="current-user-role">{ROLES[user?.role]}</div>
          </div>
          <button
            data-testid="logout-button"
            onClick={async () => { await logout(); nav("/login"); }}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-red-300 hover:bg-red-500/10 transition-colors"
          >
            <LogOut className="w-4 h-4" /> <span className="hidden lg:inline">Cerrar sesión</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
